<p *ngIf="label" class="u-text--medium u-m-bottom--minor">
	{{ label }}

	<span *ngIf="isOptional && !hideOptional" class="u-text--sm u-text--grey-blue u-text--normal">(optioneel)</span>
</p>

<div [class.c-dropdown--disabled]="control?.disabled" [class.c-dropdown--error]="hasErrors()" class="c-dropdown">
	<div (click)="toggle()" class="c-dropdown__input">
		<div class="c-dropdown__input-content">
			<ng-container *ngIf="multi; else singleTemplate">
				<span *ngIf="!selected?.length" class="c-dropdown__placeholder">{{ placeholder }}</span>
				<ng-container *ngFor="let option of selected; let last = last">
					<ng-container [ngTemplateOutletContext]="{ $implicit: getOptionByKey(option) }" [ngTemplateOutlet]="selectedTemplate || optionTemplate"></ng-container>
					<ng-container *ngIf="!last">,&nbsp;</ng-container>
				</ng-container>
			</ng-container>

			<ng-template #singleTemplate>
				<span *ngIf="!selected; else isSelected" class="c-dropdown__placeholder">{{ placeholder }}</span>

				<ng-template #isSelected>
					<ng-container [ngTemplateOutletContext]="{ $implicit: selected }" [ngTemplateOutlet]="selectedTemplate || optionTemplate"></ng-container>
				</ng-template>
			</ng-template>
		</div>

		<div [class.c-dropdown__arrow--rotate]="isOpen" class="c-dropdown__arrow">
			<tvcore-icon name="chevron"></tvcore-icon>
		</div>

		@if (showClear && hasValue) {
			<div class="c-dropdown__clear" (click)="clear($event)">
				<tvcore-icon name="close"></tvcore-icon>
			</div>
		}
	</div>

	<div [class.c-dropdown__overlay--visible]="isOpen" class="c-dropdown__overlay">
		<div *ngIf="searchable" class="c-dropdown__search">
			<input #searchElement [formControl]="query" [placeholder]="searchablePlaceholder" type="text" />
			<tvcore-icon (click)="query.reset()" [class.visible]="query.value" name="close"></tvcore-icon>
		</div>

		<div class="c-dropdown__list">
			@if (extraOptionsTemplate) {
				<ng-container [ngTemplateOutlet]="extraOptionsTemplate"></ng-container>
			}

			<div (click)="select(option)" *ngFor="let option of data" [class.c-dropdown__item--active]="!multi && isOptionActive(option)" class="c-dropdown__item">
				<div *ngIf="multi" [class.c-checkbox--active]="isOptionActive(option)" class="c-checkbox">
					<tvcore-icon name="checkmark"></tvcore-icon>
				</div>

				<ng-container [ngTemplateOutletContext]="{ $implicit: option }" [ngTemplateOutlet]="optionTemplate"></ng-container>
			</div>
		</div>
	</div>
</div>

<ng-container *ngIf="control">
	<ng-container *ngIf="showErrors">
		<ng-content></ng-content>
	</ng-container>
</ng-container>
